import { render, staticRenderFns } from "./PdfFooter.vue?vue&type=template&id=6ae1daca&"
import script from "./PdfFooter.vue?vue&type=script&lang=js&"
export * from "./PdfFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports